export const UNSCHEDULED_PANEL_TARGET = 'jsw-calendar-unscheduled-panel-target';
export const VIEW_SETTINGS_PANEL_TARGET = 'jsw-calendar-view-settings-target';
export const CALENDAR_VIEW_MESSAGE_ID = 'jsw-calendar-view-onboarding-ep';
